const logos = [
  "Trustpilot",
  "Google Reviews",
  "BBB Accredited",
  "Inc. 5000",
  "Forbes",
  "NerdWallet",
];

export default function TrustBar() {
  return (
    <section
      data-testid="trust-bar"
      className="bg-white border-b border-slate-100 py-8"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <p className="text-center text-[11px] font-semibold uppercase tracking-[0.3em] text-slate-400 mb-6">
          Trusted by 10,000+ growing businesses nationwide
        </p>
        <div className="flex flex-wrap items-center justify-center gap-x-10 gap-y-4">
          {logos.map((l) => (
            <span
              key={l}
              className="font-display text-slate-400 hover:text-slate-700 text-sm md:text-base font-semibold tracking-tight transition"
            >
              {l}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
